var DeliveryMethod = /* @__PURE__ */ ((DeliveryMethod2) => {
  DeliveryMethod2["Delivery"] = "home-delivery";
  DeliveryMethod2["DeliveryExpress"] = "home-delivery-express";
  DeliveryMethod2["NearestPickup"] = "nearest-pick-up";
  DeliveryMethod2["Pickup"] = "pick-up";
  DeliveryMethod2["PickupPoint"] = "pick-up-point";
  DeliveryMethod2["DeliveryPremium"] = "dpd-priority-delivery";
  return DeliveryMethod2;
})(DeliveryMethod || {});
var LoyaltyCardType = /* @__PURE__ */ ((LoyaltyCardType2) => {
  LoyaltyCardType2["LUHN"] = "LUHN";
  LoyaltyCardType2["UUID"] = "UUID";
  return LoyaltyCardType2;
})(LoyaltyCardType || {});
var MultiBancoFields = /* @__PURE__ */ ((MultiBancoFields2) => {
  MultiBancoFields2["externalId"] = "paymentExternalId";
  MultiBancoFields2["externalReference"] = "paymentExternalReference";
  return MultiBancoFields2;
})(MultiBancoFields || {});
export {
  DeliveryMethod,
  LoyaltyCardType,
  MultiBancoFields
};
//# sourceMappingURL=details-order.js.map
